import React from "react";
import { AnimatePresence, motion } from "motion/react";
import { ShinyText } from "@picklebet/ui";
import { constructCurrency } from "common/currency";
import { calculateDepositBonusAmountNumber } from "types/PromotionTypes";
import { usePendingDepositClaim } from "hooks/firestore/user/usePromotionClaims";

import * as styles from "./DepositBonusBadge.module.scss";

type DepositBonusBadgeProps = {
  amount: number;
};

export const DepositBonusBadge = ({ amount }: DepositBonusBadgeProps) => {
  const { pendingDepositClaim } = usePendingDepositClaim();

  const bonusAmount = calculateDepositBonusAmountNumber(
    amount,
    pendingDepositClaim ?? undefined,
  );

  const formattedBonus = constructCurrency(bonusAmount, {
    currencyType: pendingDepositClaim?.currency,
    showDecimals: "IF_REQUIRED",
  });

  return (
    <AnimatePresence initial={false}>
      {bonusAmount > 0 && (
        <motion.div
          className={styles.badgeRow}
          initial={{ opacity: 0, height: 0 }}
          animate={{ opacity: 1, height: "auto" }}
          exit={{ opacity: 0, height: 0 }}
        >
          <div className={styles.badge} data-testid="deposit-bonus-badge">
            <ShinyText
              className={styles.shinyText}
              duration={1.2}
              repeatDelay={1.1}
            >
              +{formattedBonus} Bonus Cash
            </ShinyText>
          </div>
        </motion.div>
      )}
    </AnimatePresence>
  );
};
